var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',_vm._l((_vm.ma),function(m,i){return _c('el-col',{key:i,attrs:{"span":_vm.span}},[_c('div',{class:'month-box month' + i},[_c('b',[_vm._v(_vm._s(_vm.formatNumber(m, 1)))]),_vm._v(" "+_vm._s(_vm.plural('year', m)))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }